module.exports = __webpack_public_path__ + "static/media/bonus.03c6a059.mp3";